export default __webpack_public_path__ + "static/media/dotnet.ced38cf0.png";